import { Action, createReducer, on } from '@ngrx/store';
import {
  changeDataPreloader,
  changelayout,
  changeLayoutPosition,
  changeLayoutWidth,
  changeMode,
  changeSidebarColor,
  changeSidebarImage,
  changeSidebarSize,
  changeSidebarView,
  changeSidebarVisibility,
  changeTopbar,
  resetLayoutState
} from "./layout-action";
import {
  LAYOUT_MODE,
  LAYOUT_POSITION_TYPES,
  LAYOUT_TOPBAR_COLOR_TYPES,
  LAYOUT_TYPES,
  LAYOUT_WIDTH_TYPES,
  SIDEBAR_COLOR,
  SIDEBAR_SIZE,
  SIDEBAR_VIEW,
  SIDEBAR_VISIBILITY
} from './layout';

// IntialState
export const initialState: LayoutState = {
  LAYOUT: LAYOUT_TYPES.HORIZONTAL,
  LAYOUT_MODE: LAYOUT_MODE.LIGHTMODE,
  LAYOUT_WIDTH: LAYOUT_WIDTH_TYPES.FLUID,
  LAYOUT_POSITION: LAYOUT_POSITION_TYPES.FIXED,
  TOPBAR: LAYOUT_TOPBAR_COLOR_TYPES.LIGHT,
  SIDEBAR_COLOR: SIDEBAR_COLOR.LIGHT,
  SIDEBAR_SIZE: SIDEBAR_SIZE.LARGE,
  SIDEBAR_VIEW: SIDEBAR_VIEW.DEFAULT,
  SIDEBAR_VISIBILITY: SIDEBAR_VISIBILITY.SHOW,
}

export interface LayoutState {
  LAYOUT: string;
  LAYOUT_MODE: string;
  LAYOUT_WIDTH: string;
  LAYOUT_POSITION: string;
  TOPBAR: string;
  SIDEBAR_SIZE: string;
  SIDEBAR_VIEW: string;
  SIDEBAR_COLOR: string;
  SIDEBAR_VISIBILITY: string;
}
// Function to persist state in localStorage
const persistState = (state: LayoutState) => {
  localStorage.setItem('layoutState', JSON.stringify(state));
  localStorage.setItem('mode', state.LAYOUT_MODE);
}
const getLayoutState = () => {
  return JSON.parse(localStorage.getItem('layoutState') ?? 'null') ?? initialState;
}

// Reducer
export const layoutReducer = createReducer(
  getLayoutState(),
  on(changelayout, (state, action) => {
    document.documentElement.setAttribute('data-layout', action.layout);
    const newState = { ...state, LAYOUT: action.layout };
    persistState(newState);  // Persist to localStorage
    return newState;
  }),
  on(changeMode, (state, action) => {
    document.documentElement.setAttribute('data-bs-theme', action.mode);
    document.documentElement.setAttribute('data-sidebar', action.mode);
    const newState = { ...state, LAYOUT_MODE: action.mode };
    persistState(newState);
    return newState;
  }),
  on(changeSidebarVisibility, (state, action) => {
    document.documentElement.setAttribute('data-sidebar-visibility', action.sidebarvisibility);
    const newState = { ...state, SIDEBAR_VISIBILITY: action.sidebarvisibility };
    persistState(newState);
    return newState;
  }),
  on(changeLayoutWidth, (state, action) => {
    const size = action.layoutWidth === LAYOUT_WIDTH_TYPES.FLUID ? 'lg' : 'sm-hover';
    document.documentElement.setAttribute('data-layout-width', action.layoutWidth);
    document.documentElement.setAttribute('data-sidebar-size', size);

    const newState = { ...state, LAYOUT_WIDTH: action.layoutWidth };
    persistState(newState);
    return newState;
  }),
  on(changeLayoutPosition, (state, action) => {
    document.documentElement.setAttribute('data-layout-position', action.layoutPosition);
    const newState = { ...state, LAYOUT_POSITION: action.layoutPosition };
    persistState(newState);
    return newState;
  }),
  on(changeTopbar, (state, action) => {
    document.documentElement.setAttribute('data-topbar', action.topbarColor);
    const newState = { ...state, TOPBAR: action.topbarColor };
    persistState(newState);
    return newState;
  }),
  on(changeSidebarSize, (state, action) => {
    document.documentElement.setAttribute('data-sidebar-size', action.sidebarSize);
    const newState = { ...state, SIDEBAR_SIZE: action.sidebarSize };
    persistState(newState);
    return newState;
  }),
  on(changeSidebarView, (state, action) => {
    document.documentElement.setAttribute('data-layout-style', action.sidebarView);
    const newState = { ...state, SIDEBAR_VIEW: action.sidebarView };
    persistState(newState);
    return newState;
  }),
  on(changeSidebarColor, (state, action) => {
    console.log(action.sidebarColor);
    document.documentElement.setAttribute('data-sidebar', action.sidebarColor);
    const newState = { ...state, SIDEBAR_COLOR: action.sidebarColor };
    persistState(newState);
    return newState;
  }),
  on(changeSidebarImage, (state, action) => {
    const newState = { ...state, SIDEBAR_IMAGE: action.sidebarImage };
    persistState(newState);
    return newState;
  }),
  on(changeDataPreloader, (state, action) => {
    const newState = { ...state, DATA_PRELOADER: action.Preloader };
    persistState(newState);
    return newState;
  }),
  on(resetLayoutState, () => {
    document.documentElement.setAttribute('data-layout', 'vertical');
    document.documentElement.setAttribute('data-topbar', 'light');
    document.documentElement.setAttribute('data-sidebar', 'light');
    document.documentElement.setAttribute('data-layout-style', 'default');
    document.documentElement.setAttribute('data-bs-theme', 'light');
    document.documentElement.setAttribute('data-layout-width', 'fluid');
    document.documentElement.setAttribute('data-layout-position', 'fixed');
    document.documentElement.setAttribute('data-sidebar-image', 'none');
    document.documentElement.setAttribute('data-preloader', 'disable');
    document.documentElement.setAttribute('data-sidebar-size', 'lg');

    // Reset state to initialState and persist it
    persistState(initialState);
    return initialState;
  }),
);

// Selector
export function reducer(state: LayoutState | undefined, action: Action) {
  return layoutReducer(state, action);
}
